import { memo, useEffect, useRef } from 'react';
import gsap from 'gsap';
import { Html } from '@react-three/drei';

type VProps = {
  pos: Array<number>;
  url: string;
  visible?: boolean;
  id: string;
  classnames?: string;
  scale?: number;
};

const Shine = ({
  pos,
  url,
  visible = true,
  id,
  classnames = 'w-24 h-auto pointer-events-none',
  scale = 1,
}: VProps) => {
  const selfRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (visible && selfRef.current !== null) {
      gsap.fromTo(
        selfRef.current,
        { rotation: 0 },
        {
          rotation: 360,
          transformOrigin: '50% 50%',
          repeat: -1,
          duration: 90,
          ease: 'none',
        }
      );
      gsap.from(selfRef.current, {
        scale: 0.2,
        transformOrigin: '50% 50%',
        repeat: -1,
        duration: 2,
        yoyo: true,
        ease: 'power1',
      });
    }
  }, [visible, selfRef.current]);
  return (
    <mesh>
      <Html
        ref={selfRef}
        transform
        className={'childed'}
        position={[pos[0], pos[1], pos[2]]}
        scale={scale}
      >
        <img
          id={id}
          src={url}
          alt={'loading'}
          className={classnames}
          hidden={visible}
          style={{
            visibility: visible ? 'visible' : 'hidden',
            pointerEvents: 'none',
          }}
        />
      </Html>
    </mesh>
  );
};

export default memo(Shine);
